/* tslint:disable */
import { Question } from "./Question"

export class Questions {

		AllQuestions: Question[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Questions.ts